import { createI18n } from 'vue-i18n';
import en from './en-US';
import cn from './zh-CN';
import store from '../store'
export const LOCALE_OPTIONS = [
    { label: '简体中文', value: 'zh-CN' },
    { label: 'English', value: 'en-US' },
];
const defaultLocale = store && store.state.lang || 'en-US';




const i18n = createI18n({
    locale: defaultLocale,
    fallbackLocale: 'en-US',
    legacy: false,
    allowComposition: true,
    messages: {
        'en-US': en,
        'zh-CN': cn,
    },
});

export default i18n;
